

// Autogenerated from file 'PlegmaStaticsGen.tt'. DO NOT MODIFY
// =============================================================================
// Yodiwo Plegma Statics API
// =============================================================================
//----------------------------------------------- 
export module PlegmaStatics {
  export namespace A2mcuConfigConstants {
    export const ConfigNameSamplingPeriod: string = "INPUT_ACQUISITION";
    export const ConfigNameIrqTrigger: string = "IRQ_TRIGGER";
    export const ConfigNameSamplingSlave: string = "SAMPLING_SLAVE";
    export const ConfigNameSamplingRegister: string = "SAMPLING_REG";
    export const ConfigNameSamplingBytes: string = "SAMPLING_BYTES";
  }
  export namespace Constants {
    export const YPChannelPort: number = 14623;
    export const InvalidKeyString: string = "";
    export const ExtIpAddressKey: string = "ExternalIP";
    export const IntIpAddressKey: string = "InternalIP";
    export const HierarchySeparator: string = "/";
    export const CtrlPageUriKey: string = "controlpageuri";
  }
  export namespace ExternalServiceBlockKey {
    export const MaxLength_ServiceID: number = 32;
    export const MaxLength_BlockID: number = 32;
  }
  export namespace GraphDescriptorBaseKey {
    export const MinIDLength: number = 1;
    export const MaxIDLength: number = 32;
    export const MinKeyLength: number = 26;
    export const MaxKeyLength: number = 57;
  }
  export namespace GraphDescriptorKey {
    export const MinIDLength: number = 1;
    export const MaxIDLength: number = 10;
    export const MinKeyLength: number = 28;
    export const MaxKeyLength: number = 68;
  }
  export namespace HelperExtensions {
    export const DashReplace: string = "$$DASH$$";
  }
  export namespace ModelTypeLibrary {
    export const SwitchOnOffActuator_PortModelId: string = "OnOffSwitchActuator";
    export const SwitchOnOffSink_PortModelId: string = "OnOffSwitchSink";
    export const SwitchDimmerActuator_PortModelId: string = "DimmerActuator";
    export const LightsDimmer_PortModelId: string = "DimmableLight";
    export const LightsDimmerNormalized_PortModelId: string = "NormalizedDimmableLight";
    export const Button_PortModelId: string = "Button";
    export const ButtonFlicSingleClick_PortModelId: string = "FlicButtonSingleClick";
    export const ButtonFlicDoubleClick_PortModelId: string = "FlicButtonDoubleClick";
    export const ButtonFlicLongClick_PortModelId: string = "FlicButtonLongClick";
    export const ButtonAndroid_PortModelId: string = "AndroidButton";
    export const TextIO_PortModelId: string = "TextIO";
    export const TypeWriter_PortModelId: string = "TypeWriter";
    export const Console_PortModelId: string = "Console";
    export const CheckboxActuator_PortModelId: string = "CheckBoxActuator";
    export const CheckboxSink_PortModelId: string = "CheckBoxSink";
    export const Slider_PortModelId: string = "Slider";
    export const Progressbar_PortModelId: string = "ProgressBar";
    export const LightOnOff_PortModelId: string = "OnOffLight";
    export const LocationLatitude_PortModelId: string = "LocationLatitude";
    export const LocationLongitude_PortModelId: string = "LocationLongitude";
    export const LocationInfo_PortModelId: string = "LocationInfo";
    export const LocationAddress_PortModelId: string = "LocationAddress";
    export const LocationCountry_PortModelId: string = "LocationCountry";
    export const LocationPostalCode_PortModelId: string = "LocationPostalCode";
    export const TriggeredLocation_PortModelId: string = "Location trigger";
    export const BluetoothPowerStatus_PortModelId: string = "BluetoothPowerStatus";
    export const BluetoothConnectionStatus_PortModelId: string = "BluetoothConnectionStatus";
    export const BluetoothPairedDevices_PortModelId: string = "BluetoothPairedDevices";
    export const BluetoothDiscoveredDevices_PortModelId: string = "BluetoothDiscoveredDevices";
    export const TriggeredBluetoothDiscovery_PortModelId: string = "TriggeredBluetoothDiscovery";
    export const TriggeredBluetoothPairedDevices_PortModelId: string = "TriggeredBluetoothPairedDevices";
    export const AccelerometerSensorX_PortModelId: string = "X";
    export const AccelerometerSensorY_PortModelId: string = "Y";
    export const AccelerometerSensorZ_PortModelId: string = "Z";
    export const GyroscopeSensorX_PortModelId: string = "X";
    export const GyroscopeSensorY_PortModelId: string = "Y";
    export const GyroscopeSensorZ_PortModelId: string = "Z";
    export const RotationSensorW_PortModelId: string = "W";
    export const RotationSensorX_PortModelId: string = "X";
    export const RotationSensorY_PortModelId: string = "Y";
    export const RotationSensorZ_PortModelId: string = "Z";
    export const RotationEulerSensorPhi_PortModelId: string = "Phi";
    export const RotationEulerSensorTheta_PortModelId: string = "Theta";
    export const RotationEulerSensorPsi_PortModelId: string = "Psi";
    export const Nfc_PortModelId: string = "Nfc";
    export const BrightnessNormalized_PortModelId: string = "BrightnessNormalized";
    export const Brightness_PortModelId: string = "Brightness";
    export const ProximitySensor_PortModelId: string = "Proximity";
    export const WifiStatus_PortModelId: string = "WifiStatus";
    export const WifiRssi_PortModelId: string = "WifiRssi";
    export const WifiSsid_PortModelId: string = "WifiSsid";
    export const WifiBssid_PortModelId: string = "WifiBssid";
    export const ShakeDetector_PortModelId: string = "ShakeDetector";
    export const Camera_PortModelId: string = "Camera Feed";
    export const TriggeredCamera_PortModelId: string = "Camera trigger";
    export const OnVifCamera_PortModelId: string = "OnVifCamera";
    export const Microphone_PortModelId: string = "Microphone";
    export const SipPhone_PortModelId: string = "SipPhone";
    export const SpeechRecognition_PortModelId: string = "SpeechRecognition";
    export const Text2Speech_PortModelId: string = "Text2Speech";
    export const SoundSensor_PortModelId: string = "SoundSensor";
    export const HumiditySensor_PortModelId: string = "HumiditySensor";
    export const Buzzer_PortModelId: string = "Buzzer";
    export const TemperatureSensor_PortModelId: string = "Temperature";
    export const UltrasonicSensor_PortModelId: string = "UltrasonicSensor";
    export const Lcd_PortModelId: string = "LCD";
    export const Relay_PortModelId: string = "Relay";
    export const GestureSensorTap_PortModelId: string = "Tap";
    export const GestureSensorTouch_PortModelId: string = "Touch";
    export const GestureSensorAirwheel_PortModelId: string = "Airwheel";
    export const GestureSensorDoubleTap_PortModelId: string = "DoubleTap";
    export const GestureSensorFlick_PortModelId: string = "Flick";
    export const PositionSensorX_PortModelId: string = "X";
    export const PositionSensorY_PortModelId: string = "Y";
    export const PositionSensorZ_PortModelId: string = "Z";
    export const BeaconReaderUuid_PortModelId: string = "BeaconUUID";
    export const BeaconReaderMajorValue_PortModelId: string = "BeaconMajorValue";
    export const BeaconReaderMinorValue_PortModelId: string = "BeaconMinorValue";
    export const BeaconReaderTxPower_PortModelId: string = "BeaconTxPower";
    export const BeaconReaderDistance_PortModelId: string = "BeaconDistance";
    export const BeaconReaderRssi_PortModelId: string = "BeaconRssi";
    export const BeaconReaderTypeCode_PortModelId: string = "BeaconTypeCode";
    export const BeaconReaderTemperature_PortModelId: string = "BeaconTemperature";
    export const MagnetometerSensorX_PortModelId: string = "X";
    export const MagnetometerSensorY_PortModelId: string = "Y";
    export const MagnetometerSensorZ_PortModelId: string = "Z";
    export const Gpio_PortModelId: string = "GPIO";
    export const GpioInput_PortModelId: string = "InputGPIO";
    export const GpioOutput_PortModelId: string = "OutputGPIO";
    export const AndroidIntent_PortModelId: string = "AndroidIntent";
    export const FleetMgr_PortModelId: string = "FleetMgr";
    export const Displayer_PortModelId: string = "Displayer";
    export const Gallery_PortModelId: string = "Gallery";
    export const Flickr_PortModelId: string = "Flickr";
    export const RegionViewer_PortModelId: string = "RegionViewer";
    export const DoorlockSensor_PortModelId: string = "Doorlock sensor";
    export const AirConditionSensor_PortModelId: string = "Air condition sensor";
    export const Thermostat_PortModelId: string = "Thermostat";
    export const DoorSensor_PortModelId: string = "Door sensor";
    export const SmartPlugSensor_PortModelId: string = "Smart plug sensor";
    export const ZWaveSensor_PortModelId: string = "ZWave sensor";
    export const DataPlotter_PortModelId: string = "DataPlotter";
  }
  export namespace NodeKey {
    export const MinNodeIDLength: number = 1;
    export const MaxNodeIDLength: number = 10;
    export const MinKeyLength: number = 26;
    export const MaxKeyLength: number = 35;
    export const CloudId: number = 2147483647;
  }
  export namespace NodePairingConstants {
    export const Uuid: string = "uuid";
    export const Token1: string = "token1";
    export const Token2: string = "token2";
    export const NodeKey: string = "nodekeystr";
    export const SecretKey: string = "secretkey";
    export const PairingRootURI: string = "pairing";
    export const UserConfirmPageURI: string = "userconfirm";
    export const ApiGroupName: string = "NodePairingAPI";
    export const s_GetTokensRequest: string = "gettokensreq";
    export const s_GetKeysRequest: string = "getkeysreq";
    export const s_TokensResponse: string = "tokensrsp";
    export const s_KeysResponse: string = "keysrsp";
  }
  export namespace PlegmaAPI {
    export const APIVersion: number = 1;
    export const KeySeparator: string = "-";
    export const KeySeparatorStr: string = "-";
    export const BroadcastToken: string = "*";
    export const RestAPIBaseRoute: string = "api";
    export const ApiGroupName: string = "PlegmaAPI";
    export const ApiLogicGroupName: string = "PlegmaAPI.Logic";
    export const ThingModelTypeSeparator: string = ".";
    export const ThingModelTypeSeparatorStr: string = ".";
    export const ThingModelTypeDefault: string = "default";
    export const ThingModelTypeSeparatorPlusDefault: string = ".default";
    export const s_LoginReq: string = "loginreq";
    export const s_LoginRsp: string = "loginrsp";
    export const s_NodeInfoReq: string = "nodeinforeq";
    export const s_NodeInfoRsp: string = "nodeinforsp";
    export const s_NodeUnpairedReq: string = "nodeunpairedreq";
    export const s_NodeStatusChangedReq: string = "nodestatuschangedreq";
    export const s_EndpointSyncReq: string = "endpointsyncreq";
    export const s_EndpointSyncRsp: string = "endpointsyncrsp";
    export const s_ThingsGet: string = "thingsget";
    export const s_ThingsSet: string = "thingsset";
    export const s_PortEventMsg: string = "porteventmsg";
    export const s_PortEventReq: string = "porteventreq";
    export const s_PortEventRsp: string = "porteventrsp";
    export const s_PortStateGet: string = "portstateget";
    export const s_PortStateSet: string = "portstateset";
    export const s_ActivePortKeysMsg: string = "activeportkeysmsg";
    export const s_PingReq: string = "pingreq";
    export const s_PingRsp: string = "pingrsp";
    export const s_BlockEventFeedbackMsg: string = "blockeventfeedbackmsg";
    export const s_VirtualBlockEventMsg: string = "virtualblockeventmsg";
    export const s_LocallyDeployedGraphsMsg: string = "locallydeployedgraphsmsg";
    export const s_GraphDeploymentReq: string = "graphdeploymentreq";
    export const s_A2mcuActiveDriversReq: string = "A2mcuactivedriversreq";
    export const s_A2mcuCtrlReq: string = "A2mcuctrlreq";
    export const s_GenericRsp: string = "genericrsp";
    export const s_FcmConnectionMsg: string = "fcmconnectionmsg";
    export const s_FcmDisconnectionMsg: string = "fcmdisconnectionmsg";
  }
  export namespace Port {

    /**
     * Revnum indicating no tracking of revision numbers
     */
    export const RevNum_NoTracking: number = 0;

    /**
     * Revnum indicating initialization of port (as if portstate was followed by thing addditiong)
     */
    export const RevNum_Initialize: number = 1;
  }
  export namespace PortKey {
    export const VirtThingTriggerPortId: string = "YInternalTrigger";
  }
  export namespace PortModelLibrary {
    export const WS_CHECKBOX: string = "com.yodiwo.portmodels.checkbox.value";
    export const WS_DIMMABLELIGHT: string = "com.yodiwo.portmodels.dimmerlight.value";
    export const WS_CONSOLE: string = "com.yodiwo.portmodels.console.text";
    export const WS_BUTTON: string = "com.yodiwo.portmodels.button.value";
    export const WS_SLIDER: string = "com.yodiwo.portmodels.slider.value";
    export const WS_TEXT: string = "com.yodiwo.portmodels.text.value";
    export const ZWAVE_DOORSENSOR_TYPE: string = "com.yodiwo.portmodels.zwave.doorsensor.type";
    export const ZWAVE_DOORSENSOR_VALUE: string = "com.yodiwo.portmodels.zwave.doorsensor.value";
    export const ZWAVE_WRITE: string = "com.yodiwo.portmodels.zwave.writevalue";
    export const ZWAVE_NODEIN: string = "com.yodiwo.portmodels.zwave.nodein";
    export const ZWAVE_CONFIGREGISTER: string = "com.yodiwo.portmodels.zwave.configregister";
    export const ZWAVE_CONFIGVALUE: string = "com.yodiwo.portmodels.zwave.configvalue";
    export const ZWAVE_ADDNODE: string = "com.yodiwo.portmodels.zwave.addnode";
    export const ZWAVE_REMOVENODE: string = "com.yodiwo.portmodels.zwave.removenode";
    export const ZWAVE_GETNODE: string = "com.yodiwo.portmodels.zwave.getnode";
    export const ZWAVE_GROUP: string = "com.yodiwo.portmodels.zwave.groupassoc";
    export const AVM_SNAPSHOT_TRIGGER: string = "com.yodiwo.portmodels.avm.snapshottrigger";
    export const AVM_SNAPSHOT_DESCRIPTOR: string = "com.yodiwo.portmodels.avm.snapshotdescriptor";
    export const AVM_STREAM_URI: string = "com.yodiwo.portmodels.avm.videodescriptor";
    export const AVM_STREAM_LOCALSOURCE: string = "com.yodiwo.portmodels.avm.streamlocalsrc";
    export const AVM_AUDIO_DESCRIPTOR: string = "com.yodiwo.portmodels.avm.audiiodescriptor";
    export const AVM_PLACEHOLDER: string = "com.yodiwo.portmodels.avm.placeholder";
    export const OZWAVE_WRITE: string = "com.yodiwo.portmodels.ozw.writevalue";
    export const OZWAVE_NODEIN: string = "com.yodiwo.portmodels.ozw.nodein";
    export const OZWAVE_ADDNODE: string = "com.yodiwo.portmodels.ozw.addnode";
    export const OZWAVE_REMOVENODE: string = "com.yodiwo.portmodels.ozw.removenode";
    export const OZWAVE_GETNODE: string = "com.yodiwo.portmodels.ozw.getnode";
    export const OZWAVE_GROUP: string = "com.yodiwo.portmodels.ozw.groupassoc";
    export const OZWAVE_CMD: string = "com.yodiwo.portmodels.ozw.cmdclassid";
    export const OZWAVE_CMDLABEL: string = "com.yodiwo.portmodels.ozw.cmdclassidlabel";
    export const OZWAVE_TARGETNODEID: string = "com.yodiwo.portmodels.ozw.targetnodeid";
    export const YZWAVE_NODEOUT: string = "com.yodiwo.portmodels.yzw.nodeout";
    export const YZWAVE_READTYPE: string = "com.yodiwo.portmodels.yzw.readtype";
    export const YZWAVE_READVALUE: string = "com.yodiwo.portmodels.yzw.readvalue";
    export const YZWAVE_RESPONSE: string = "com.yodiwo.portmodels.yzw.response";
    export const YZWAVE_NODESTATUS: string = "com.yodiwo.portmodels.yzw.nodstatus";
    export const YZWAVE_READJSON: string = "com.yodiwo.portmodels.yzw.readjson";
    export const ZWAVE_POWERPLUG_SWITCH: string = "com.yodiwo.portmodels.zwave.powerplug.switch";
    export const ZWAVE_POWERPLUG_SWITCHALL: string = "com.yodiwo.portmodels.zwave.powerplug.switchall";
    export const ZWAVE_POWERPLUG_VALUE: string = "com.yodiwo.portmodels.zwave.powerplug.value";
    export const ZWAVE_POWERPLUG_TYPE: string = "com.yodiwo.portmodels.zwave.powerplug.type";
    export const ZWAVE_POWERPLUG_WRITE: string = "com.yodiwo.portmodels.zwave.powerplug.writevalue";
    export const FLIC_SINGLE: string = "com.yodiwo.portmodels.flic.single";
    export const FLIC_DOUBLE: string = "com.yodiwo.portmodels.flic.double";
    export const FLIC_LONG: string = "com.yodiwo.portmodels.flic.long";
  }
  export namespace SubUserKey {
    export const MinSubUserIdLength: number = 5;
    export const MaxSubUserIdLength: number = 100;
    export const MinKeyLength: number = 30;
    export const MaxKeyLength: number = 125;
  }
  export namespace ThingKey {
    export const NodeModuleIdSeparator: string = ":";
  }
  export namespace ThingTypeLibrary {
    export const Gpio_Type: string = "com.yodiwo.gpios";
    export const GpioDefault_ModelType: string = "default";
    export const GpioInput_ModelType: string = "input";
    export const GpioOutput_ModelType: string = "output";
    export const Text_Type: string = "com.yodiwo.text";
    export const TextIO_ModelType: string = "default";
    export const TextTypewriter_ModelType: string = "typewriter";
    export const TextConsole_ModelType: string = "console";
    export const Switch_Type: string = "com.yodiwo.switches";
    export const SwitchActuator_ModelType: string = "actuator.onoff";
    export const SwitchActuatorCheckBox_ModelType: string = "actuator.checkbox";
    export const SwitchActuatorRelay_ModelType: string = "actuator.relay";
    export const SwitchActuatorDimmer_ModelType: string = "actuator.dimmer";
    export const SwitchActuatorAndroid_ModelType: string = "actuator.android";
    export const SwitchSink_ModelType: string = "sink.onoff";
    export const SwitchSinkCheckBox_ModelType: string = "sink.checkbox";
    export const SwitchSinkAndroid_ModelType: string = "sink.android";
    export const Lights_Type: string = "com.yodiwo.lights";
    export const LightsDimmer_ModelType: string = "dimmer";
    export const LightsDimmerNormalized_ModelType: string = "dimmer.normalized";
    export const LightsAndroid_ModelType: string = "android";
    export const LightsBoolean_ModelType: string = "onoff";
    export const Seekbar_Type: string = "com.yodiwo.seekbars";
    export const SeekbarSlider_ModelType: string = "slider";
    export const SeekbarProgressbar_ModelType: string = "progressbar";
    export const Button_Type: string = "com.yodiwo.buttons";
    export const ButtonFlic_ModelType: string = "flic";
    export const ButtonAndroid_ModelType: string = "android";
    export const ButtonDefault_ModelType: string = "default";
    export const Location_Type: string = "com.yodiwo.location";
    export const LocationCoordinates_ModelType: string = "coordinates";
    export const LocationInfo_ModelType: string = "info";
    export const LocationCoordinatesTriggered_ModelType: string = "coordinates.triggered";
    export const LocationInfoTriggered_ModelType: string = "info.triggered";
    export const Wifi_Type: string = "com.yodiwo.wifi";
    export const WifiStatus_ModelType: string = "status";
    export const WifiRssi_ModelType: string = "rssi";
    export const WifiSsid_ModelType: string = "ssid";
    export const WifiBssid_ModelType: string = "bssid";
    export const WifiInfo_ModelType: string = "info";
    export const Bluetooth_Type: string = "com.yodiwo.bluetooth";
    export const BluetoothDefault_ModelType: string = "default";
    export const BluetoothTriggered_ModelType: string = "triggered";
    export const Camera_Type: string = "com.yodiwo.cameras";
    export const CameraDefault_ModelType: string = "default";
    export const CameraTriggered_ModelType: string = "trigger";
    export const CameraOnVif_ModelType: string = "onvif";
    export const BeaconReader_Type: string = "com.yodiwo.beacon";
    export const BeaconReaderDefault_ModelType: string = "default";
    export const BeaconReaderSensors_ModelType: string = "withsensors";
    export const Nfc_Type: string = "com.yodiwo.nfc";
    export const NfcDefault_ModelType: string = "default";
    export const AndroidIntent_Type: string = "com.yodiwo.androidintent";
    export const AndroidIntentDefault_ModelType: string = "default";
    export const Microphone_Type: string = "com.yodiwo.microphones";
    export const MicrophoneDefault_ModelType: string = "default";
    export const Buzzer_Type: string = "com.yodiwo.buzzers";
    export const BuzzerDefault_ModelType: string = "default";
    export const SipPhone_Type: string = "com.yodiwo.sipphones";
    export const SipPhoneDefault_ModelType: string = "default";
    export const SpeechRecognition_Type: string = "com.yodiwo.speechrecognition";
    export const SpeechRecognitionDefault_ModelType: string = "default";
    export const Text2Speech_Type: string = "com.yodiwo.text2speech";
    export const Text2SpeechDefault_ModelType: string = "default";
    export const Sensor_Type: string = "com.yodiwo.sensors";
    export const GestureSensor_ModelType: string = "gesture";
    export const PositionSensor_ModelType: string = "position";
    export const AccelerometerSensor_ModelType: string = "accelerometer";
    export const RotationSensor_ModelType: string = "rotation";
    export const RotationEulerSensor_ModelType: string = "rotation.euler";
    export const GyroscopeSensor_ModelType: string = "gyroscope";
    export const MagnetometerSensor_ModelType: string = "magnetometer";
    export const SoundSensor_ModelType: string = "sound";
    export const HumiditySensor_ModelType: string = "humidity";
    export const TemperatureSensor_ModelType: string = "temperature";
    export const HTSensor_ModelType: string = "humiditytemperature";
    export const LightSensor_ModelType: string = "brightness";
    export const LightSensorNonNormalized_ModelType: string = "brightness.nonNormalized";
    export const ProximitySensor_ModelType: string = "proximity";
    export const ProximityUltrasonicSensor_ModelType: string = "proximity.ultrasonic";
    export const DoorSensor_ModelType: string = "door";
    export const SmartPlugSensor_ModelType: string = "smart.plug";
    export const DoorlockSensor_ModelType: string = "doorlock";
    export const AirConditionSensor_ModelType: string = "air.condition";
    export const Thermostat_ModelType: string = "thermostat";
    export const ZWaveSensor_ModelType: string = "z-wave";
    export const ShakeDetectorSensor_ModelType: string = "shakedetector";
    export const Lcd_Type: string = "com.yodiwo.lcds";
    export const LcdDefault_ModelType: string = "default";
    export const FleetMgr_Type: string = "com.yodiwo.fleetmgr";
    export const FleetMgrDefault_ModelType: string = "default";
    export const Displayer_Type: string = "com.yodiwo.displayer";
    export const DisplayerDefault_ModelType: string = "default";
    export const Gallery_Type: string = "com.yodiwo.gallery";
    export const GalleryDefault_ModelType: string = "default";
    export const Flickr_Type: string = "com.yodiwo.flickr";
    export const FlickrDefault_ModelType: string = "default";
    export const RegionViewer_Type: string = "com.yodiwo.regionviewer";
    export const RegionViewerDefault_ModelType: string = "default";
    export const Label_Type: string = "com.yodiwo.label.default";
    export const DataPlotter_Type: string = "com.yodiwo.dataplotter";
    export const DataPlotterDefault_ModelType: string = "default";
  }
  export namespace ThingTypes {
    export const Yodiwo_Logic_BlockLibrary_SipThingOut: string = "Yodiwo.Logic.Blocks.Things.SipThingOut";
    export const Yodiwo_Logic_BlockLibrary_ScreenStreamerThing: string = "Yodiwo.Logic.Blocks.Things.ScreenStreamerThing";
  }
  export namespace UserKey {
    export const MinUserIDLength: number = 24;
    export const MaxUserIDLength: number = 24;
    export const MinKeyLength: number = 24;
    export const MaxKeyLength: number = 24;
  }
}

